import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled } from '@mui/material/styles';
import useGlobalStatus from '../../hook/useGlobalStatus';
import theme from '../../theme';

const Footer = styled('footer')(props => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // marginRight: '2%',
  padding: '0',
  fontSize: '12px',
  color: theme.palette.grey.main
}))

const Copyright = ({ child }) => {
  const { drawerOpen } = useGlobalStatus();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const year = new Date().getFullYear();

  // const contentLeft = () => {
  //   let marginLeft;
  //   if (drawerOpen && isDesktop) {
  //     marginLeft = 250;
  //   } else if (!drawerOpen && isDesktop) {
  //     marginLeft = 60;
  //   } else {
  //     marginLeft = 0;
  //   }
  //   return marginLeft;
  // }

  return (
    <Box
      component="footer"
      sx={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        // border: '1px solid blue'
      }}
    >
      <Footer child={child}>
        <p>Copyright ©{year} HAI INC. All rights reserved.</p>

        {/* <LinkExternalCustom
            style={props.style}
            href="/user-terms"
            target="_blank"
            sx={{ ml: '10px' }}>
            服務條款
          </LinkExternalCustom>

          <LinkExternalCustom
            style={props.style}
            href="/privacy"
            target="_blank"
            sx={{ ml: '10px' }}>
            隱私權政策
          </LinkExternalCustom> */}

      </Footer>
    </Box>
  )
}

export default Copyright;